function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCmtDetail = function SvgIconCmtDetail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "k1bu519uia"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 11843",
    style: {
      fill: "#dfe2e6"
    },
    d: "M0 0h14v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uC544\\uC774\\uCF58_\\uB313\\uAE00\\uAC2F\\uC218",
    style: {
      clipPath: "url(#k1bu519uia)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37205",
    d: "m13.443 15-3.628-1.3A6.808 6.808 0 0 1 7 14.3a6.88 6.88 0 0 1-4.95-2.095 7.261 7.261 0 0 1 0-10.114 6.9 6.9 0 0 1 9.9 0A7.183 7.183 0 0 1 14 7.152a7.265 7.265 0 0 1-1.419 4.316zm-3.7-2.631 1.983.71-.466-1.91.2-.24a6 6 0 0 0 1.333-3.777A5.862 5.862 0 0 0 7 1.234a5.862 5.862 0 0 0-5.792 5.918A5.862 5.862 0 0 0 7 13.069a5.636 5.636 0 0 0 2.521-.588z",
    style: {
      fill: "#a8afb9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 15163",
    transform: "translate(1.579 6.085)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 84",
    cx: 0.933,
    cy: 0.933,
    transform: "translate(7.288)",
    style: {
      fill: "#a8afb9"
    },
    r: 0.933
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 85",
    cx: 0.933,
    cy: 0.933,
    transform: "translate(4.488)",
    style: {
      fill: "#a8afb9"
    },
    r: 0.933
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 86",
    cx: 0.933,
    cy: 0.933,
    transform: "translate(1.688)",
    style: {
      fill: "#a8afb9"
    },
    r: 0.933
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCmtDetail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_cmt_detail.a5096f9f.svg";
export { ForwardRef as ReactComponent };